import PropTypes from 'prop-types'
import React from 'react'
import {Route} from 'react-router-dom'

const ExternalRouteRedirect = ({externalPath, ...props}) => (
  <Route
    {...props}
    render={() => {
      window.location.href = externalPath
      return null
    }}
  />
)

ExternalRouteRedirect.propTypes = {
  externalPath: PropTypes.string.isRequired,
}

export default ExternalRouteRedirect
